import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import DetailFooter from "./DetailFooter.js";
const DetailFooterContainer = ({ ...detailFooterProps }) => {
  const { getLabel, currency } = useIntl();
  const labels = {
    paymentMethod: getLabel("account.subscription.payment.method"),
    additionalDiscount: getLabel("common.additionalDiscount"),
    free: getLabel("common.free"),
    shipping: getLabel("common.shipping"),
    subtotal: getLabel("common.subtotal"),
    total: getLabel("common.total")
  };
  return /* @__PURE__ */ React.createElement(DetailFooter, { ...detailFooterProps, currency, labels });
};
export {
  DetailFooterContainer as default
};
//# sourceMappingURL=DetailFooterContainer.js.map
